import { render, staticRenderFns } from "./DocumentLabel.vue?vue&type=template&id=d6dc3f16&"
import script from "./DocumentLabel.vue?vue&type=script&lang=js&"
export * from "./DocumentLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports